import React, { useState } from "react";
import Navbar from "./Navbar";
import "./header.css";
import Logo from "../acepts/logo-24.png";
import { NavLink } from "react-router-dom";

export const navbar = [
  { id: 1, path: "/", title: "awigej" },
  { id: 2, path: "/", title: "World" },
  { id: 3, path: "/", title: "World" },
  { id: 4, path: "/", title: "World" },
  { id: 5, path: "/", title: "Science and technology" },
  { id: 6, path: "/", title: "World" },
];

export const dropdovn = [
  { id: 1, dropTitle: "Samarqand" },
  { id: 2, dropTitle: "Samarqand" },
  { id: 3, dropTitle: "Samarqand" },
  { id: 4, dropTitle: "Samarqand" },
  { id: 5, dropTitle: "Samarqand" },
  { id: 6, dropTitle: "Samarqand" },
  { id: 7, dropTitle: "Samarqand" },
];

export const langLeft = [
  { id: 1, title: "Уз" },
  { id: 2, title: "O'z" },
  { id: 3, title: "Eng" },
  { id: 4, title: "Py" },
];

function Header(props) {
  const [search, setSearch] = useState(true);
  const [chevron, setChevron] = useState(true);

  const handleSearch = () => {
    setSearch(!search);
  };
  const handChevron = () => {
    setChevron(!chevron);
  };
  return (
    <div className="header_parent">
      <div className="header_head">
        <div className="containers">
          <div className="header_top">
            <Navbar />
            <div className="icons">
              <a href="https://www.facebook.com/tahlil24/"><i className="bi bi-facebook"></i></a>
              <a href="https://twitter.com/tahlil24?t=za_WYLijk6A-rFmZ0pHZwQ&s=09"><i className="bi bi-twitter"></i></a>
              <a href="https://www.instagram.com/tahlil24_uz/"><i className="bi bi-instagram"></i></a>
              <a href="https://t.me/tahlil24uz"><i className="bi bi-telegram"></i></a>
            </div>
          </div>
          <div className="navbar_bottom">
            <div className="search_bottom">
              <i onClick={handleSearch} className="bi bi-search"></i>
              <div className={search ? "input_search_bottom" : "search_active"}>
                <input type="text" placeholder="Search..." />
                <i onClick={handleSearch} className="bi bi-x-lg"></i>
              </div>
            </div>
            <NavLink to="/">
              <img src={Logo} alt="Logo img" />
            </NavLink>
            {/* navbar left */}
            <button
              className="btn btn-bottom"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
            >
              <i className="bi bi-list"></i>
            </button>

            <div
              className="offcanvas offcanvas-end shadow-lg"
              tabindex="-1"
              id="offcanvasRight"
              aria-labelledby="offcanvasRightLabel"
            >
              <div className="offcanvas-header shadow-sm">
                <h5
                  className="offcanvas-title d-flex align-center"
                  id="offcanvasRightLabel"
                >
                  {langLeft.map((lang) => (
                    <div key={lang.id} className="lang_radius">
                      {lang.title}
                    </div>
                  ))}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div className="offcanvas-body">
                <ul>
                  <button
                    class="btn btn-bottom_left"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseExample"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                    onClick={handChevron}
                  >
                    Uzbekistan
                    {chevron ? (
                      <i className="bi bi-chevron-right"></i>
                    ) : (
                      <i className="bi bi-chevron-down"></i>
                    )}
                  </button>
                  <div class="collapse" id="collapseExample">
                    <div class="card card-body">
                      {dropdovn.map((drop) => (
                        <span className="drop_left" key={drop.id}>
                          {drop.dropTitle}
                        </span>
                      ))}
                    </div>
                  </div>
                  {navbar.map((navbar) => (
                    <li key={navbar.id}>
                      <NavLink to={navbar.path}>{navbar.title}</NavLink>
                    </li>
                  ))}
                </ul>
                <div className="nav_left">
                  <div className="nav_icons">
                    <div className="nav_icon_item">
                    <a href="https://t.me/tahlil24uz"><i className="bi bi-telegram"></i></a>
                      <h3>Telegram</h3>
                    </div>
                    <div className="nav_icon_item">
                    <a href="https://twitter.com/tahlil24?t=za_WYLijk6A-rFmZ0pHZwQ&s=09"><i className="bi bi-twitter"></i></a>
                      <h3>twitter</h3>
                    </div>
                    <div className="nav_icon_item">
                    <a href="https://www.instagram.com/tahlil24_uz/"><i className="bi bi-instagram"></i></a>
                      <h3>Instagram</h3>
                    </div>
                    <div className="nav_icon_item">
                    <a href="https://www.facebook.com/tahlil24/"><i className="bi bi-facebook"></i></a>
                      <h3>Facebook</h3>
                    </div>
                  </div>
                  <div className="nav_left_item">
                    <h3>
                      <NavLink to="/about">About</NavLink>
                    </h3>
                    <h3>
                      <NavLink to="/contact">Contacts</NavLink>
                    </h3>
                    <h3>
                      <NavLink to="/advrtise">Advertise</NavLink>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            {/* navbar left */}
          </div>
          <div className="header_center">
            <NavLink to="/">
              <img src={Logo} alt="Logo img" />
            </NavLink>
            <div className="navbar">
              <ul>
                <li className="drop_parent">O'zbekistan
                  <ol className="dropdovn_child">
                    {dropdovn.map(item => (
                      <li key={item.id} className="drop_li"><a href="/">{item.dropTitle}</a></li>
                    ))}
                  </ol>
                </li>
                {navbar.map((navbar) => (
                  <li key={navbar.id}>
                    <NavLink to={navbar.path}>{navbar.title}</NavLink>
                  </li>
                ))}
              </ul>
            </div>
            <form className="header_center_icons">
              <i class="bi bi-globe2"></i>
              <select name="" id="">
                <option value="">English</option>
                <option value="">O'zbekcha</option>
                <option value="">Ўзбекча</option>
                <option value="">Русский</option>
              </select>
              <div className="search">
                <i class="bi bi-search"></i>
                <input type="text" className="input_search" />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
